import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { loginUser } from "../actions/actions";

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: "",
			username: "",
			password: "",
			login: "Log in"
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillMount() {
		const authToken = reactLocalStorage.get("authToken", false);
		const club = reactLocalStorage.get("club", false);
		const resource = reactLocalStorage.get("resource", false);
		if (authToken && club && resource) {
			this.redirectTimer = window.setInterval(() => {
				this.props.handleNav("checkin");
			}, 90000);
		}
	}

	componentWillUnmount() {
		clearInterval(this.redirectTimer);
	}

	handleChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.value;
		this.setState({ [name]: value });
	}

	handleSubmit(event) {

		this.setState({
			error: "",
			login: "Logging In..."
		});

		const username = this.state.username;
		const password = this.state.password;

		loginUser({ username, password })
			.then(response => {
				if ( !response ) {
					this.setState({error: "Incorrect Username or Password."});
				} else if ( "authenticated" === response ) {

					this.props.handleNav("studioChoice");
				}
				this.setState({
					login: "Log in"
				});
			})
			.catch(error => {
				console.stack(error);
			});
		event.preventDefault();
	}

	render() {
		return (
			<div className="login-screen">
				<img
					src={process.env.PUBLIC_URL + "/images/icon-gear.svg"}
					alt="Gear icon"
					className="icon-gear"
				/>
				<p className="error">{this.state.error}</p>
				<form onSubmit={this.handleSubmit}>
					<div className="form-field">
						<label htmlFor="username">Username:</label>
						<input
							value={this.state.username}
							onChange={this.handleChange}
							type="text"
							name="username"
							id="username"
							placeholder="Username"
						/>
					</div>
					<div className="form-field">
						<label htmlFor="password">Password:</label>
						<input
							value={this.state.password}
							onChange={this.handleChange}
							type="password"
							name="password"
							id="password"
							placeholder="Password"
						/>
					</div>
					<button className="-alt">{this.state.login}</button>
				</form>
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/layouts/LoginForm.js